export default __webpack_public_path__ + "static/media/tempo-dashboard.1ac80f70.svg";